import { configureStore } from "@reduxjs/toolkit";
import LoginReducer from "./slices/loginSlice";
import PhoneReducer from "./slices/phoneSlice";
import ImgReducer from "./slices/imgSlice";
import OffersReducer from "./slices/offersSlice";
import LocReducer from "./slices/locSlice";
import getApiInfo from "./slices/getApiInfoSlice";
import { combineReducers } from "redux";
import localforage from "localforage";

import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";

const persistConfig = {
  timeout: 1000,
  key: "root",
  version: 1,
  storage: localforage,
  // PG-P3: do NOT persist heavy/stale/dead/transient slices. The cold-boot
  // bottleneck was PersistGate rehydrating the `app` (getApiInfo) blob from
  // IndexedDB before first paint — banners/categories/feed/profile/dummyFile.
  // Home refetches all of that on mount, so persisting it only delayed paint
  // with no correctness value. `login` is dead state (auth uses
  // localStorage["token-off"], not redux); `img`/`offers` hold transient
  // edit-image scratch. Only the tiny `phone` + `location` slices stay
  // persisted. Any previously stored blacklisted blob self-purges on the next
  // persist write, so no version bump/migration is needed.
  blacklist: ["app", "login", "img", "offers"],
};

const reducer = combineReducers({
  login: LoginReducer,
  phone: PhoneReducer,
  img: ImgReducer,
  offers: OffersReducer,
  location: LocReducer,
  app: getApiInfo,
});

const persistedReducer = persistReducer(persistConfig, reducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        ignoredPaths: ["app.someNonSerializableField"],
      },
      immutableCheck: false,
    }),
});

export default store;
